<script>
import {Link} from "@inertiajs/vue3";

export default {
	components: {Link},
	emits: ['backToOverview'],
	props: {
		cancelRoute: {
			type: String,
			required: false
		},
		formId: {
			type: String,
			required: true
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	inject: {
		assetFieldValidity: {default: null}
	},
	computed: {
		missingMetadataCount() {
			if (!this.assetFieldValidity) {
				return 0;
			}
			return Object.values(this.assetFieldValidity).reduce((total, count) => total + count, 0);
		},
		saveBlockedHint() {
			if (this.missingMetadataCount < 1) {
				return null;
			}
			return 'Er zijn bestanden waarvoor nog verplichte velden ingevuld moeten worden.';
		},
		saveDisabled() {
			return this.loading || this.missingMetadataCount > 0;
		}
	}
}
</script>

<template>
	<div class="d-flex gap-2 align-items-center">
		<Link v-if="cancelRoute" :href="cancelRoute" class="btn btn-secondary">Annuleren</Link>

		<button :form="formId" :class="{'btn btn-primary': true, 'loading' : loading}" :disabled="saveDisabled" :title="saveBlockedHint">
			<span>Opslaan</span>
		</button>

		<button @click="$emit('backToOverview')" :form="formId" :class="{'btn btn-primary': true, 'loading' : loading}" :disabled="saveDisabled" :title="saveBlockedHint">
			Opslaan en sluiten
		</button>

		<span v-if="saveBlockedHint" class="text-warning small">
			<i class="bi bi-exclamation-triangle-fill"></i>
			{{ saveBlockedHint }}
		</span>
	</div>
</template>
